// extracted by mini-css-extract-plugin
export default {"actions":"login-report_actions__3x1oG","container":"login-report_container__oEM9e","title":"login-report_title__UDxTc"};